// Lib
import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

// Components
import Icon from '../../../../components/icons/Icon';
import Button from '../../../../components/buttons/Button';
import { openSheet } from '../../../structural/sheet/sheetActions';

// Types
import { SheetId } from '../../../structural/sheet/sheetTypes';

const MobileSearchTool = (): ReactElement => {
    const dispatch = useDispatch();
    const dispatchOpenSheet = () => dispatch(openSheet(SheetId.SearchTool));

    return (
        <>
            <Button className="MobileSearchTool mobile-util-button" onClick={dispatchOpenSheet}>
                <Icon name="mobile-toolbar-search" />
                <div className="label">Search</div>
            </Button>
        </>
    );
};

export default MobileSearchTool;
